import { styled } from '@linaria/react';
export const Header = /*#__PURE__*/styled('div')({
  name: "Header",
  class: "h1h6kz03",
  propsAsIs: false
});
export const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h1gjsgvc",
  propsAsIs: false
});
export const HeaderContent = /*#__PURE__*/styled('div')({
  name: "HeaderContent",
  class: "h1cb2bqt",
  propsAsIs: false
});
export const SubHeader = /*#__PURE__*/styled('div')({
  name: "SubHeader",
  class: "s1irp4ym",
  propsAsIs: false
});
export const OverlayContent = /*#__PURE__*/styled('div')({
  name: "OverlayContent",
  class: "o1omans3",
  propsAsIs: false
});
export const Handle = /*#__PURE__*/styled('div')({
  name: "Handle",
  class: "hjvymjr",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");